// Reorder product elements on mobile (portrait and landscape)
function shouldReorder() {
  return window.matchMedia('(max-width: 749px)').matches || 
         (window.matchMedia('(max-width: 1024px) and (orientation: landscape)').matches);
}

if (shouldReorder()) {
  document.addEventListener('DOMContentLoaded', function() {
    const quantityWrapper = document.querySelector('.quantity-button-wrapper');
    const calculatorRow = document.querySelector('.calculator-shipping-row');
    
    if (quantityWrapper && calculatorRow) {
      const quantitySection = quantityWrapper.querySelector('.product-form__quantity');
      const atcSection = quantityWrapper.querySelector('.inline-button-atc');
      const calculatorSection = calculatorRow.querySelector('.calculator-section');
      const shippingSection = calculatorRow.querySelector('.shipping-section');
      
      if (quantitySection && atcSection && calculatorSection && shippingSection) {
        // Order: Quantity → Deck Calculator → ATC → Freight Shipping
        quantitySection.after(calculatorSection);
        calculatorSection.after(atcSection);
        atcSection.after(shippingSection);
        
        // Remove the now-empty calculator-shipping-row
        calculatorRow.remove();
      }
    }
  });
}

// Also handle orientation changes
window.addEventListener('orientationchange', function() {
  if (shouldReorder()) {
    // Small delay to ensure layout has updated
    setTimeout(function() {
      const quantityWrapper = document.querySelector('.quantity-button-wrapper');
      const calculatorRow = document.querySelector('.calculator-shipping-row');
      
      if (quantityWrapper && calculatorRow) {
        const quantitySection = quantityWrapper.querySelector('.product-form__quantity');
        const atcSection = quantityWrapper.querySelector('.inline-button-atc');
        const calculatorSection = calculatorRow.querySelector('.calculator-section');
        const shippingSection = calculatorRow.querySelector('.shipping-section');
        
        if (quantitySection && atcSection && calculatorSection && shippingSection) {
          // Check if already reordered
          if (!quantitySection.nextElementSibling || 
              quantitySection.nextElementSibling !== calculatorSection) {
            quantitySection.after(calculatorSection);
            calculatorSection.after(atcSection);
            atcSection.after(shippingSection);
            calculatorRow.remove();
          }
        }
      }
    }, 100);
  }
});
